import MenuList from '@mui/material/MenuList';
import Popper from '@mui/material/Popper';
import Grow from '@mui/material/Grow';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';

interface MenuListDecoratorProps {
  open: boolean,
  anchorEl: HTMLButtonElement | null,
  onClickAway: (event: any) => void,
  children: React.ReactNode,
}

// See more: https://material-ui.com/components/menus/#menulist-composition
const MenuListDecorator = (props: MenuListDecoratorProps) => {
  const { open, anchorEl, onClickAway, children } = props;
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      role={undefined}
      transition
      disablePortal
      placement="bottom-end"
      modifiers={[
        { name: 'preventOverflow', enabled: false },
        { name: 'flip', enabled: false },
      ]}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: placement === 'bottom-end' ? 'top right' : 'center bottom' }}
        >
          <Paper>
            <ClickAwayListener onClickAway={onClickAway}>
              <MenuList>
                {children}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};

export default MenuListDecorator;
